import moment from 'moment'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import Loader from '../../common/loader/Loader'
import { ReactComponent as MailIcon } from '../../../assets/images/common/icons/mail-icon.svg'
import { ReactComponent as DeleteIcon } from '../../../assets/images/common/icons/programBuilder/delete-icon.svg'
import classes from './InvitedTable.module.scss'
import React from 'react'


const InvitedTable = ({ invitations, onResendInvite, onDeleteInvite }) => {
  if (!invitations) {
    return (
      <div className='h-100 d-flex align-items-center justify-content-center'>
        <Loader>Loading Invitations</Loader>
      </div>
    )
  }

  return (
    <div id='invitedTable' className={classes.table}>
      <div className={classes.gridTable} id='tableContent'>
        <div className={classNames(classes.col, classes.header, classes.firstColumn, classes.topLeft)}>
          <span className='font-weight-bold'>Students ({invitations?.length || 0})</span>
        </div>
        <div className={classNames(classes.col, classes.header)}>
          Invited On
        </div>
        <div className={classNames(classes.col, classes.header)}>
          Email
        </div>
        <div className={classNames(classes.col, classes.header)}>
          Invited By
        </div>
        <div className={classNames(classes.col, classes.header)}>
          Resend Invite
        </div>
        <div className={classNames(classes.col, classes.header)} />

        {invitations.map(invitation => (
          <div key={invitation.id} className={classNames(classes.row)}>
            <div
              className={classNames(classes.col, classes.firstColumn, classes.studentInfo)}
              title={`${invitation.firstName} ${invitation.lastName}`}
            >
              <p className='font-weight-bold m-0'>{invitation.firstName} {invitation.lastName}</p>
            </div>

            <div className={classNames(classes.col, classes.centeredCol)}>
              <span className='font-weight-bold'>{invitation.inviteDate ? moment(invitation.inviteDate).format('LLL') : '-'}</span>
            </div>

            <div className={classNames(classes.col, classes.centeredCol)}>
              <span>{invitation.email || ''}</span>
            </div>

            <div className={classNames(classes.col, classes.centeredCol)}>
              <span className='font-weight-bold'>{invitation.invitedBy}</span>
            </div>

            <div className={classNames(classes.col, classes.centeredCol)}>
              <button onClick={() => onResendInvite(invitation)} className={classes.button}>
                <MailIcon className={classes.icon} />
                Resend Invite
              </button>
            </div>

            <div className={classNames(classes.col, classes.centeredCol)}>
              <button onClick={() => onDeleteInvite(invitation)} className={classNames(classes.button, classes.deleteButton)}>
                <DeleteIcon className={classes.icon} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

InvitedTable.propTypes = {
  invitations: PropTypes.array,
  isLoading: PropTypes.bool,
  onResendInvite: PropTypes.func,
  onDeleteInvite: PropTypes.func,
}

export default InvitedTable
